import { ReactComponent as QuoteSvg } from 'assets/svgs/quote.svg'

import * as S from "./Advice.style"

const Advice = ({ title, paragraph, children, showQuote, authorName, authorProfessionalPosition }) => {
    return (
        <S.Container $showQuote={showQuote}>
            {showQuote && (
                <S.Quote>
                    <QuoteSvg />
                </S.Quote>
            )}
            {title && (<S.Title variant="headline-02">{title}</S.Title>)}
            {paragraph && (<S.Paragraph>{paragraph}</S.Paragraph>)}
            {children}
            {authorName && (
                <S.Author>
                    <strong>{authorName}</strong>
                    {authorProfessionalPosition && (<span>{authorProfessionalPosition}</span>)}
                </S.Author>
            )}
        </S.Container>
    );
};

export default Advice;